module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "doc"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('ul', [_vm._l((_vm.data), function(i) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": i.path
      }
    }, [_vm._v(_vm._s(i.name))])], 1)
  }), _vm._v(" "), _vm._l((_vm.data), function(i) {
    return _c('li', [_c('a', {
      attrs: {
        "href": "https://github.com/Yiiu/everyone"
      }
    }, [_vm._v("github")])])
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.9.9.5@vue-loader/lib/template-compiler.js?id=data-v-a85d2494!./~/.9.9.5@vue-loader/lib/selector.js?type=template&index=0!./doc/components/nav.vue
// module id = 492
// module chunks = 27